import Vue from 'vue'
import Vuex from 'vuex'
import globalConfigApi from '@/api/global-config'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:null,
    devicecode: "",
    loading:false,
    globalConfig: {}
  },
  mutations: {
    SET_TOKEN(state,token){
      state.token=token;
    },
    SET_DEVICECODE(state,devicecode){
      state.devicecode=devicecode;
    },
    SET_LOADING(state,isShow){
      state.loading=isShow;
    },
    SET_GLOBALCONFIG(state,config){
      state.globalConfig=config;
    }
  },
  actions: {
    setToken({commit},token){
      commit("SET_TOKEN",token);
    },
    setDeviceCode({commit},devicecode){
      commit("SET_DEVICECODE",devicecode)
    },
    setLoading({commit},isShow){
      commit("SET_LOADING",isShow);
    },
    setConfig({commit}){
      globalConfigApi().then(v =>{
        commit("SET_GLOBALCONFIG",v.data)
      })
    },
    login(){
      // router.replace("./login?devicecode="+this.state.devicecode)
      router.replace("./login")
    }
  }
})
